import React, { FC, ReactNode } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
}

const PageError: FC<IProps> = ({ children }) => {
  return <div className={css.page__error}>{children}</div>;
};

export default PageError;
